module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.ttf";